(function() {
  if (typeof window.debounce !== 'function') {
    window.debounce = function(fn, wait) {
      var t;
      return function() {
        var ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function() { fn.apply(ctx, args); }, wait);
      };
    };
  }
})();

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    var handleRemove = function(event) {
      event.preventDefault();
      var cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems) cartItems.updateQuantity(this.dataset.index, 0, event);
    }.bind(this);

    this.addEventListener('click', handleRemove);
    this.addEventListener('touchend', function(e) {
      e.preventDefault();
      handleRemove(e);
    }, { passive: false });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = (typeof debounce === 'function' ? debounce : window.debounce)((event) => {
      this.onChange(event);
    }, typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate(event);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (isNaN(inputValue) || inputValue < 0) {
      return;
    }

    const min = event.target.dataset.min ? parseInt(event.target.dataset.min) : 0;
    const max = event.target.max ? parseInt(event.target.max) : null;
    const step = event.target.step ? parseInt(event.target.step) : 1;

    if (window.quickOrderListStrings) {
      if (inputValue < min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', min);
      } else if (max !== null && inputValue > max) {
        message = window.quickOrderListStrings.max_error.replace('[max]', max);
      } else if (step > 1 && inputValue % step !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', step);
      }
    } else {
      if (inputValue < min) {
        message = `A quantidade mínima é ${min}`;
      } else if (max !== null && inputValue > max) {
        message = `A quantidade máxima é ${max}`;
      } else if (step > 1 && inputValue % step !== 0) {
        message = `Só é possível adicionar este item em incrementos de ${step}`;
      }
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      const activeElementName = document.activeElement
				? document.activeElement.getAttribute('name')
				: null
			this.updateQuantity(
				index,
				inputValue,
				event,
				activeElementName,
				event.target.dataset.quantityVariantId
			)
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate(event) {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      const source = event && event.detail && event.detail.source;
      const skipFooterReplace = source === 'product-form' || source === 'ec-complementary-bundle' || source === 'ec-cart-upsell' || source === 'quick-add';
      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
      return fetch(`${cartUrl}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = skipFooterReplace ? ['cart-drawer-items'] : ['cart-drawer-items', '.drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          if (skipFooterReplace) {
            const drawerFooter = document.querySelector('.drawer__footer');
            const newDrawerFooter = html.querySelector('.drawer__footer');
            if (drawerFooter && newDrawerFooter) {
              const ecCartFooter = drawerFooter.querySelector('.ec-cart-footer');
              const newEcCartFooter = newDrawerFooter.querySelector('.ec-cart-footer');
              if (ecCartFooter && newEcCartFooter) {
                const subtotalEl = ecCartFooter.querySelector('.ec-cart-footer__subtotal-value');
                const newSubtotalEl = newEcCartFooter.querySelector('.ec-cart-footer__subtotal-value');
                const totalEl = ecCartFooter.querySelector('.ec-cart-footer__total-value');
                const newTotalEl = newEcCartFooter.querySelector('.ec-cart-footer__total-value');
                const pixEl = ecCartFooter.querySelector('.ec-payment-pix-value');
                const newPixEl = newEcCartFooter.querySelector('.ec-payment-pix-value');
                const installmentEl = ecCartFooter.querySelector('.ec-payment-installment-value');
                const newInstallmentEl = newEcCartFooter.querySelector('.ec-payment-installment-value');
                if (subtotalEl && newSubtotalEl) {
                  subtotalEl.textContent = newSubtotalEl.textContent;
                  subtotalEl.setAttribute('data-cart-subtotal-sem-desconto', newSubtotalEl.getAttribute('data-cart-subtotal-sem-desconto') || '0');
                }
                if (totalEl && newTotalEl) {
                  totalEl.textContent = newTotalEl.textContent;
                  totalEl.setAttribute('data-cart-subtotal', newTotalEl.getAttribute('data-cart-subtotal') || '0');
                }
                if (pixEl && newPixEl) pixEl.textContent = newPixEl.textContent;
                if (installmentEl && newInstallmentEl) installmentEl.textContent = newInstallmentEl.textContent;
              }
              const checkoutBtn = drawerFooter.querySelector('#CartDrawer-Checkout');
              const newCheckoutBtn = newDrawerFooter.querySelector('#CartDrawer-Checkout');
              if (checkoutBtn && newCheckoutBtn) checkoutBtn.replaceWith(newCheckoutBtn);
            }
          }
          document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: { source: 'onCartUpdate' } }));
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const sections = [];
    
    const cartItemsElement = document.getElementById('main-cart-items');
    if (cartItemsElement && cartItemsElement.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: cartItemsElement.dataset.id,
        selector: '.js-contents',
      });
    }
    
    const cartIconBubble = document.getElementById('cart-icon-bubble')
		if (cartIconBubble) {
			sections.push({
				id: 'cart-icon-bubble',
				section: cartIconBubble.dataset.id || 'cart-icon-bubble',
				selector: '.shopify-section'
			})
		}

		const cartLiveRegion = document.getElementById('cart-live-region-text')
		if (cartLiveRegion) {
			sections.push({
				id: 'cart-live-region-text',
				section: cartLiveRegion.dataset.id || 'cart-live-region-text',
				selector: '.shopify-section'
			})
		}

    const cartFooterElement = document.getElementById('main-cart-footer');
    if (cartFooterElement && cartFooterElement.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: cartFooterElement.dataset.id,
        selector: '.js-contents',
      });
    }
    
    return sections;
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = typeof CartPerformance !== 'undefined'
      ? CartPerformance.createStartingMarker(`${eventTarget}:user-action`) : null;

    this.enableLoading(line);

    const cartChangeUrl = (typeof routes !== 'undefined' && routes.cart_change_url) ? routes.cart_change_url : '/cart/change';
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(cartChangeUrl, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text().then((text) => ({ ok: response.ok, text }));
      })
      .then(({ ok, text: state }) => {
        const parsedState = JSON.parse(state);
        if (!ok || parsedState.message) {
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
          return;
        }

        const doMeasure = typeof CartPerformance !== 'undefined'
          ? (fn) => CartPerformance.measure(`${eventTarget}:paint-updated-sections`, fn)
          : (fn) => fn();
        doMeasure(() => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            if (quantityElement) {
              quantityElement.value = quantityElement.getAttribute('value');
            }
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
						const sectionElement = document.getElementById(section.id)
						if (!sectionElement) return
						const elementToReplace =
							(section.selector ? sectionElement.querySelector(section.selector) : null) || sectionElement
						if (!parsedState.sections || !parsedState.sections[section.section]) return
						const sectionHtml = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						)
						if (sectionHtml) {
							elementToReplace.innerHTML = sectionHtml
						}
					})

					document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
          document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: { source: 'updateQuantity' } }));

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
        if (typeof CartPerformance !== 'undefined' && cartPerformanceUpdateMarker) {
          CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.textContent = message;
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        if (cartStatus) {
          cartStatus.setAttribute('aria-hidden', true);
        }
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) {
      document.activeElement.blur();
    }
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          (typeof debounce === 'function' ? debounce : window.debounce)((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300)
        );
      }
    }
  );
}

if (typeof customElements.get('cart-drawer-items') === 'undefined') {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }
  }
  customElements.define('cart-drawer-items', CartDrawerItems);
}
